/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, FormHelperText ,Grid } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import { format } from 'date-fns';


function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

var screenCode = "FDCINBOUNDTRANSACTOINSREPORT"

export default function FDCInboundTransactionsReport() {
    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [fromDatevalue, setFromDateValue] = useState(new Date());
    const [toDatevalue, setToDateValue] = useState(new Date());
    const [gtnWiseSummaryDetails, setGtnWiseSummaryDetails] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [totalValue, setTotalValue] = useState(0);
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'FDC Inbound Transactions Report'
    });
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        date: null,
        isActive: true
    });
    const [totalValues, setTotalValues] = useState({
        kgQuantityTotal: 0,
        unitQuantityTotal: 0,
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        factoryName: '',
        date: ''
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, gtnWiseSummaryDetails.length - page * rowsPerPage);

    const DailyPurchasingEfficiencySummaryReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh distribution center').min(1, 'Please select at least one Fresh distribution center'),
    });

    const truncateSheetName = (name) => {
        return name.length > 31 ? name.substring(0, 31) : name;
    }

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            date: formData.date,
            isActive: formData.isActive
        },
        validationSchema: DailyPurchasingEfficiencySummaryReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;
    useEffect(() => {
        getPermissions()
    }, []);

    useEffect(() => {
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
        setFromDateValue(new Date());
        setToDateValue(new Date());
    }, [formik.values.groupID]);

    useEffect(() => {
        setGtnWiseSummaryDetails([]);
        setFromDateValue(new Date());
        setToDateValue(new Date());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setGtnWiseSummaryDetails([]);
    }, [fromDatevalue, toDatevalue]);

    useEffect(() => {
        setToDateValue(new Date());
    }, [fromDatevalue]);

    useEffect(() => {
        setGtnWiseSummaryDetails([]);
        setFromDateValue(new Date());
        setToDateValue(new Date());
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        if (factory.length === 0) {
            setSelectedOptions([]);
            return;
        }

        const availableFactoryIds = factory.map((option) => option.value);
        const defaultFactoryId = 1;

        setSelectedOptions((prevSelectedOptions) => {
        const validSelectedOptions = (prevSelectedOptions || []).filter((id) =>
            availableFactoryIds.includes(id)
        );

        if (validSelectedOptions.length > 0) {
            return validSelectedOptions;
        }

        if (availableFactoryIds.includes(defaultFactoryId)) {
            return [defaultFactoryId];
        }

        if (!permissionList.isFactoryFilterEnabled) {
            const tokenFactoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
            return availableFactoryIds.includes(tokenFactoryValue) ? [tokenFactoryValue] : [];
        }

        return [];
        });
    }, [factory, permissionList.isFactoryFilterEnabled]);

    useEffect(() => {
        if (gtnWiseSummaryDetails.length != 0) {
            calculateTotal()
        }    
    }, [gtnWiseSummaryDetails]);

    function calculateTotal() {
        const total = gtnWiseSummaryDetails.reduce((acc, item) => acc + (parseFloat(item.totalValue) || 0), 0);
        setTotalValue(total);
    }
    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            fromDate: fromDatevalue == null ? null : moment(fromDatevalue).format('YYYY-MM-DD'),
            toDate: toDatevalue == null ? null : moment(toDatevalue).format('YYYY-MM-DD'),
        }
        var res = await services.GetFDCInboundTransactionsReportData(model)
        getTotalValues(model)
        setGtnWiseSummaryDetails(res);
        getSelectedDropdownValuesForReport(model);
        setPage(0);
    }

    async function getTotalValues(model){
        var res = await services.GetFDCInboundTransactionsReportaTotalValues(model)
        setTotalValues(res);
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFDCINBOUNDTRANSACTOINSREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)

        })
        trackPromise(GetAllGroups());

    }

    async function clearAll() {
        setFromDateValue(new Date());
        setToDateValue(new Date());
        if (!permissionList.isFactoryFilterEnabled) {
            setSelectedOptions([]);
        } else {
            setSelectedOptions([]);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetFDCList(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createFile() {
        const formattedFromDate = format(fromDatevalue, 'yyyy-MM-dd');
        const formattedToDate = format(toDatevalue, 'yyyy-MM-dd');

        var file = await createDataForExcel(gtnWiseSummaryDetails);
        var settings = {
            sheetName: 'FDC Inbound Transactions Report',
            fileName: `FDC Inbound Transactions Report - ${formattedFromDate} - ${formattedToDate}`,
            writeOptions: {}
        };
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: truncateSheetName('FDC Inbound Transactions Report'),
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        const res = [];
        if (array != null) {
            array.forEach(x => {
                res.push({
                    'GTN No': x.grnNumber || x.GrnNumber || '-',
                    'Lorry Number': x.lorryNumber || '-',
                    'SKU Code': x.skuCode || x.productCode || x.productCodeCode || '-',
                    'SKU Name': x.skuName || x.productName || '-',
                    'GRN Date': new Date(x.grnDate).toLocaleDateString() || '-',
                    'FCC Code': x.factoryCode || '-',
                    'FCC Name': x.factoryName || '-',
                    'Quantity': parseFloat(x.quantity).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || '-',
                    'Value(LKR)': parseFloat(x.totalValue).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || '-'
                });
                });
                res.push({
                    'GTN No': 'Total',
                    'Lorry Number': '',
                    'SKU Code': '',
                    'SKU Name': '',
                    'Date': '',
                    'FCC Code': '',
                    'FCC Name': '',
                    'Quantity': '',
                    'Value(LKR)':  parseFloat(totalValue).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }) || '-'
                });

                res.push({
                    'GTN No': '',
                    'Lorry Number': '',
                    'SKU Code': '',
                    'SKU Name': '',
                    'Date': '',
                    'FCC Code': '',
                    'FCC Name': '',
                    'Quantity': '',
                    'Value(LKR)': ''
                });
        
                res.push({
                    'GTN No': 'KG Quantity Total',
                    'Lorry Number': parseFloat(totalValues.kgQuantityTotal).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }) || '-',
                    'SKU Code': '',
                    'SKU Name': '',
                    'Date': '',
                    'FCC Code': '',
                    'FCC Name': '',
                    'Quantity': '',
                    'Value(LKR)': ''
                });

                res.push({
                    'GTN No': 'UNIT Quantity Total',
                    'Lorry Number': parseFloat(totalValues.unitQuantityTotal).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }) || '-',
                    'SKU Code': '',
                    'SKU Name': '',
                    'Date': '',
                    'FCC Code': '',
                    'FCC Name': '',
                    'Quantity': '',
                    'Value(LKR)': ''
                });      
            }
    
        return res;
    }

    function getSelectedDropdownValuesForReport(data) {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });
        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues((prevState) => ({
            ...prevState,
            groupName: groups.groupName,
            factoryName: facName.length == 0 ? 'All Fresh Distribution Centers' : facName.join(', '),
            date: new Date(fromDatevalue).toLocaleDateString()
        }));
    }

    return (
        <>
            <LoadingComponent />
            <Page title="FDC Inbound Transactions Report |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group </MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label" >Fresh Distribution Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Distribution Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Distribution Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            size="small"
                                            label="From Date *"
                                            openTo="day"
                                            type="date"
                                            value={fromDatevalue}
                                            onChange={(newValue) => {
                                                setFromDateValue(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            size="small"
                                            label="To Date *"
                                            openTo="day"
                                            type="date"
                                            value={toDatevalue}
                                            onChange={(newValue) => {
                                                setToDateValue(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                    <div>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </div>
                                </Stack>
                                <br />
                                {gtnWiseSummaryDetails.length != 0 ?
                                <>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                            <TableContainer component={Paper} >
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left">GTN No</TableCell>
                                                            <TableCell align="left">Lorry Number</TableCell>
                                                            <TableCell align="left">SKU Code</TableCell>
                                                            <TableCell align="left">SKU Name</TableCell>
                                                            <TableCell align="left">GRN Date</TableCell>
                                                            <TableCell align="left">FCC Code</TableCell>
                                                            <TableCell align="left">FCC Name</TableCell>
                                                            <TableCell align="right">Quantity</TableCell>
                                                            <TableCell align="right">Value(LKR)</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(rowsPerPage > 0
                                                            ? gtnWiseSummaryDetails
                                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            : gtnWiseSummaryDetails
                                                        ).map((row) => (
                                                            <TableRow key={`${row.grnNumber || row.GrnNumber || 'NA'}-${row.skuCode || row.productCode || row.productCodeCode}-${row.factoryID}`}>
                                                                <TableCell align="left">
                                                                    {row.grnNumber || row.GrnNumber || '-'}
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    {row.lorryNumber}
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    {row.skuCode || row.productCode || row.productCodeCode || '-'}
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    {row.skuName || row.productName || '-'}
                                                                </TableCell>
                                                                 <TableCell align="left">
                                                                    {moment(new Date(row.grnDate)).format('YYYY-MM-DD')}
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    {row.factoryCode}
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    {row.factoryName}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {parseFloat(row.quantity).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {parseFloat(row.totalValue).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: "bold" }} align="left" colSpan={8}>
                                                                Total
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValue).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                        </TableRow>
                                                        {emptyRows > 0 && (
                                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                                <TableCell colSpan={6} />
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TablePagination
                                                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                colSpan={9}
                                                                count={gtnWiseSummaryDetails.length}
                                                                rowsPerPage={rowsPerPage}
                                                                page={page}
                                                                SelectProps={{
                                                                    inputProps: {
                                                                        'aria-label': 'rows per page',
                                                                    },
                                                                    native: true,
                                                                }}
                                                                onPageChange={handleChangePage}
                                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                                ActionsComponent={TablePaginationActions}
                                                            />
                                                        </TableRow>
                                                    </TableFooter>
                                                </Table>
                                            </TableContainer>
                                        </Card>
                                    </Stack> 
                                     <>
                                     <Grid container spacing={3} style={{ marginTop: '40px', paddingTop: '1px' }}>
                                         <Grid item md={2} xs={12} style={{ paddingTop: '1px' }}>
                                             <b> KG Quantity Total </b>
                                         </Grid>
                                         <Grid item md={2} xs={12} style={{ paddingTop: '1px' }}>
                                             <b>:&nbsp;{totalValues.kgQuantityTotal == 0 || totalValues.kgQuantityTotal == undefined? '-' : parseFloat(totalValues.kgQuantityTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                         </Grid>
                                     </Grid>
                                     <Grid container spacing={3} style={{ paddingTop: '1px' }}>
                                         <Grid item md={2} xs={12} style={{ paddingTop: '1px' }}>
                                             <b> UNIT Quantity Total </b>
                                         </Grid>
                                         <Grid item md={2} xs={12} style={{ paddingTop: '1px' }}>
                                             <b>:&nbsp;{totalValues.unitQuantityTotal == 0 || totalValues.unitQuantityTotal == undefined ? '-' : parseFloat(totalValues.unitQuantityTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                         </Grid>
                                     </Grid>
                                     </>
                                    </>
                                    : <SearchNotFound searchQuery="FDC Inbound Transactions Report"/>}
                            </Stack>
                        </Form>
                    </FormikProvider>

                    {gtnWiseSummaryDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"GTN Wise Summary Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    gtnWiseSummaryDetails={gtnWiseSummaryDetails}
                                    searchData={selectedSearchValues}
                                    totalValue={totalValue}
                                    totalValues={totalValues}
                                />
                            </div>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );
}

